import { Code2, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function CivicDataApisPage() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <div className="flex items-center gap-3">
          <Code2 className="h-6 w-6 text-violet-400" />
          <h1 className="text-2xl font-bold text-white">Civic Data APIs</h1>
          <Badge variant="default" className="text-[10px]">Coming Soon</Badge>
        </div>
        <p className="text-sm text-slate-400 mt-1">
          API documentation and developer resources
        </p>
      </div>

      <Card>
        <CardContent className="py-12 text-center space-y-4">
          <Code2 className="h-12 w-12 text-slate-600 mx-auto" />
          <h2 className="text-lg font-semibold text-white">
            API Documentation — Coming Soon
          </h2>
          <p className="text-sm text-slate-400 max-w-md mx-auto">
            Developer portal with REST API documentation, rate limits, authentication guides,
            example code, SDKs, and webhook configuration for integrating election data.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-blue-400 hover:text-blue-300 transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Back to Elections
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
